import axios from "axios";
import { Toast } from "vant";
let request = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,
    // baseUrl: "https://hrs.iliving.cn/",
    withCredentials: true,
    timeout: 1000 * 60,
});
request.interceptors.request.use(
    config => {
        if (config.method == "get") {
            config.params ? false : (config.params = {});
            config.params.channel = process.env.VUE_APP_CHANNEL;
        } else {
            config.data ? false : (config.data = {});
            config.data.channel = process.env.VUE_APP_CHANNEL;
        }
        return config;
    },
    error => {
        return Promise.error(error);
    }
);
request.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if (response.data && response.data.code != 200) {
                // Toast(response.data.msg);
                if (response.data.code == 401) {
                    location = "/#/noPermission";
                } else if (response.data.code == 408) {
                    Toast(response.data.msg);
                }
            }
            return Promise.resolve(response.data);
        } else {
            return Promise.reject(response.data);
        }
    },
    error => {
        return Promise.reject(error);
    }
);
export default request;
